import React from 'react';

import styled from '@emotion/styled';

import { BREAKPOINTS, unit } from '@zego/theme';

import ContentContainer from '@zego/components/ContentContainer';
import StaticBackgroundImage from '@zego/components/StaticBackgroundImage';

import curveMask from './_curveMask.svg';

const BackdropMask = styled('div')({
  position: 'absolute',
  pointerEvents: 'none',
  bottom: -1,
  left: 0,
  right: 0,
  height: '100%',
  transform: 'rotate(0.01deg)',
  backgroundImage: `url(${curveMask})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'bottom',
  backgroundSize: 'contain',
});

const Hero = ({ children, image, promo, bgBlend }) => (
  <StaticBackgroundImage
    src={image}
    css={{
      position: 'relative',
      marginTop: -100,
      [BREAKPOINTS.normal]: {
        marginTop: -(50 + 100),
      },
    }}
  >
    <div
      css={{
        backgroundColor: bgBlend,
        height: '100%',
        paddingTop: 100,
        [BREAKPOINTS.medium]: {
          paddingBottom: 24,
        },
        [BREAKPOINTS.normal]: {
          paddingTop: 50 + 100,
        },
      }}
    >
      <BackdropMask />
      {promo}
      <ContentContainer
        css={{
          paddingTop: unit(1),
          paddingBottom: unit(1),
        }}
      >
        {children}
      </ContentContainer>
    </div>
  </StaticBackgroundImage>
);

export default Hero;
